export enum offersStatusEnum {
	Current_Offers = 0,
	Ended_Offers = 1,
}

export enum offerType {
	PromoCode = 0,
}

export enum offerMethod {
	Fixed = 0,
	Percentage = 1,
}
export const offersStatus: {
	name: string
	value: string
}[] = []

Object.keys(offersStatusEnum).forEach((value: string) =>
	isNaN(+value)
		? offersStatus.push({
				name: value,
				value: offersStatusEnum[value as any],
		  })
		: null
)
